import { AUTH_URL, AUTH_API_TOKEN, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const authAxiosInstaceV1 = axios.create({
  baseURL: `${AUTH_URL}/api/v1`,
  headers: {
    'api-token': AUTH_API_TOKEN
  }
})
authAxiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
}, function(error) {
  if (error.response.status === 401) {
    EventBus.$emit('unauthorized')
  }
  if (error.response.status !== 404) {
    EventBus.$emit('show-error-modal', error)
  }
  return Promise.reject(error)
})
export const AuthAPI = {

  /**
   * Login user with Email and Password
   * @param {string} [data={ email: '', password: '' }]
   * @returns {Promise}
   */
  login (data = { email: '', password: '' }) {
    return authAxiosInstaceV1({
      method: 'post',
      data: data,
      url: `/auth/login/local`,
      headers: {
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  /**
   *
   * Login user with userToken
   * @param {*} token
   * @returns
   */
  loginWithToken (token) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/users/profile`,
      headers: {
        'auth-token': token,
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user locations
   *
   * @returns {Promise}
   */
  getUserLocations() {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/locations/',
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user businesses
   *
   * @returns {Promise}
   */
  getUserBusinesses () {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/users/businesses',
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user businesses when not logged in
   *
   * @returns {Promise}
   */
  getUserBusinessesNotLoggedIn (token) {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/users/businesses',
      headers: {
        'auth-token': token,
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  /**
   * Call to set users active business
   *
   * @param {*} businessId
   * @returns {Promise}
   */
  setActiveBusiness (businessId) {
    return authAxiosInstaceV1({
      method: 'patch',
      url: `/users/businesses/${businessId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  /**
   *  Call to get a business by id
   *
   * @returns {Promise}
   */
  getBusinessById (businessId, withBranding = false) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/businesses/${businessId}?withBranding=${withBranding}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  getUsersForABusiness (businessId) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/businesses/${businessId}/users?inactive=true`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  updateUserById (userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/users/${userId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  toggleCorporateUser (userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/users/${userId}/businesses/corporate`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  toggleAdminUser (userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/users/${userId}/businesses/admin`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  toggleUserStatus (userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/users/${userId}/businesses/status`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  inviteANewUser (data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/invitations`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  getInvitationDetails (id) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/invitations/${id}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  checkIfUserExist (data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/invitations/user_check`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  inviteExistingUser (userId, data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/invitations/users/${userId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  getAllOpenInvitations () {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/invitations`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  getInvitationById (id) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/invitations/${id}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  preAssignRoles (invId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/invitations/${invId}/roles`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  changePassword (data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/passwords`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  changePasswordByUserId (userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/users/${userId}/passwords`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },
  cancelAnInvitation (invId) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/invitations/${invId}/cancel`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  updateBusinessBranding (businessId, data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/businesses/${businessId}/branding`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },

  createBusiness(data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/businesses`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },

  getAllBusinesses(data) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/businesses`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      params: {
        withBranding: data ? data.withBranding : false
      }
    })
  },
  getBusinessSettings (businessId) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/businesses/${businessId}/settings`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  updateBusinessSettings (businessId, settingId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/businesses/${businessId}/settings/${settingId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },

  getUsersforLoacation(locationId, page, limit) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/locations/${locationId}/users`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      params: {
        page: page || 1,
        limit: limit || 10
      }
    })
  },

  addUserToLocation(userId, data) {
    return authAxiosInstaceV1({
      method: 'post',
      url: `/locations/users/${userId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },

  deleteUserFromLocation(userId, data) {
    return authAxiosInstaceV1({
      method: 'delete',
      url: `/locations/users/${userId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  },

  logout() {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/users/logout`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  getUserSettings(userId) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `users/${userId}/settings`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  updateUserSettings(userId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `users/${userId}/settings/`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      },
      data
    })
  }
}
